'use es6';

import Raven from 'Raven';
const ENDPOINT_EXPOSURE_BULK_LOG = `treatments/v2/exposure/log-bulk`;
const ENDPOINT_TREATMENTS_BULK_GET = `treatments/v2/bulk-get`;
const SENTRY_EXTRA_OPTS = {
  fingerprint: ['laboratory-lib', 'network']
};

function ensureFn(fn, fallback = () => {}) {
  if (typeof fn !== 'function') {
    return fallback;
  }

  return fn;
}

function logError(err) {
  if (typeof err === 'string') {
    ensureFn(console.log)(err);
  } else {
    ensureFn(console.error)(err);
  }
}

export function reportError(err) {
  try {
    if (typeof err === 'string') {
      Raven.captureMessage(err, SENTRY_EXTRA_OPTS);
    } else {
      Raven.captureException(err, SENTRY_EXTRA_OPTS);
    }

    logError(err);
  } catch (err2) {
    logError(err2);
  }
}
export function logExposures({
  apiDomain = '',
  exposures,
  http,
  onError
} = {}) {
  return http.post(`${apiDomain}/${ENDPOINT_EXPOSURE_BULK_LOG}`, {
    data: exposures
  }).catch(ensureFn(onError));
}
export function getTreatmentsFromHttp({
  apiDomain = '',
  ceid,
  data,
  http,
  onComplete,
  onError,
  timeout
} = {}) {
  if (timeout === 0) {
    ensureFn(onError)(new Error('laboratory-lib - hub-http timeout'));
  } else {
    const query = {};

    if (ceid) {
      query.ceid = ceid;
    }

    http.post(`${apiDomain}/${ENDPOINT_TREATMENTS_BULK_GET}`, {
      timeout,
      data,
      query
    }).then(onComplete).catch(ensureFn(onError));
  }
}
export function getTreatmentsFromQuickFetch({
  onComplete,
  onError,
  quickFetch,
  quickFetchLabel,
  timeout
}) {
  const requestState = quickFetch.getRequestStateByName(quickFetchLabel);

  if (!requestState) {
    ensureFn(onError)(new Error(`laboratory-lib expected window.quickFetch.getRequestStateByName("${quickFetchLabel}") to return request state.`));
  } else if (timeout === 0) {
    ensureFn(onError)(new Error('laboratory-lib - quick-fetch timeout'));
  } else {
    const timeoutInterval = setInterval(() => {
      ensureFn(onError)(new Error('laboratory-lib - quick-fetch timeout'));
      clearInterval(timeoutInterval);
    }, timeout);
    requestState.whenFinished(treatments => {
      onComplete(treatments);
      clearInterval(timeoutInterval);
    });
    requestState.onError((xhr, err) => {
      ensureFn(onError)(err);
      clearInterval(timeoutInterval);
    });
  }
}